
import React, { useState, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { format } from 'date-fns';
import axiosInstance from '../axiosConfig';
import { useNavigate } from 'react-router-dom'; 
import Header from '../Components/Header';
import Sidebar from '../Components/Sidebar';
import '../styles.css';

const MyCalendar = () => {
  const [userData, setUserData] = useState(null);  
  const currentUserId = localStorage.getItem('id');
  const [data, setData] = useState({});
  const [events, setEvents] = useState([]);
  const [attendanceDetails, setAttendanceDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [allAttendanceData, setAllAttendanceData] = useState([]);
  const [popupData, setPopupData] = useState({});
  const [isIdCardPopupVisible, setIsIdCardPopupVisible] = useState(false);

  useEffect(() => {
    const screenWidth = window.innerWidth;
    if (screenWidth < 520) {
      setIsSidebarVisible(false);
    } else {
      setIsSidebarVisible(true);
    }
  }, []);

  const handleToggleClick = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  useEffect(() => {
    if (currentUserId) {
      axiosInstance.get(`/user/${currentUserId}/`)
        .then((response) => setUserData(response.data))
        .catch((error) => console.error('Error fetching user data:', error));
    }
  }, [currentUserId]);
  
  useEffect(() => {
    fetchAllAttendanceData(); 
  }, []);
  
  const fetchAllAttendanceData = async () => {
    try {
      const response = await axiosInstance.get(`/attendance/user/${currentUserId}/`);
      setAllAttendanceData(response.data);
      const formattedEvents = formatAttendanceData(response.data);
      setEvents(formattedEvents);

      const details = calculateAttendanceDetails(response.data);
      setAttendanceDetails(details);
    } catch (error) {
      console.error('Error fetching attendance data:', error);
    }
  };

  useEffect(() => {
    axiosInstance.get('/leave-balance/')
      .then((response) => {
        setData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }, []);

  const formatAttendanceData = (attendance) => {
    return attendance.map((item) => {
      let color;
      switch (item.status) {
        case 'present':
          color = '#22c55e';
          break;
        case 'absent':
          color = '#ef4444';
          break;
        case 'leave':
          color = '#a855f7';
          break;
        case 'halfday':
          color = '#f47522';
          break;
        case 'missed_punch':
          color = '#3b82f6';
          break;
        case 'holiday':
        case 'weekly_off':
          color = '#6b7280';
          break;
        default:
          color = '#6b7280';
      }
      return {
        title: item.status.charAt(0).toUpperCase() + item.status.slice(1),
        date: item.date,
        backgroundColor: color,
        borderColor: color,
        textColor: '#fff',
        punchInTime: item.punch_in_time,
        punchOutTime: item.punch_out_time,
      };
    });
  };

  const calculateAttendanceDetails = (attendance) => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();
  
    const attendanceThisMonth = attendance.filter((item) => {
      const itemDate = new Date(item.date);
      return itemDate.getMonth() === currentMonth && itemDate.getFullYear() === currentYear;
    });
  
    const totalPresentDaysThisMonth = attendanceThisMonth.filter((item) => item.status === 'present').length;
    const totalAbsentDaysThisMonth = attendanceThisMonth.filter((item) => item.status === 'absent').length;
    const totalHalfDaysThisMonth = attendanceThisMonth.filter((item) => item.status === 'halfday').length;
  
    return {
      totalPresentDaysThisMonth,
      totalAbsentDaysThisMonth,
      totalHalfDaysThisMonth,
      currentStatus: attendanceThisMonth.find((item) => item.date === format(new Date(), 'yyyy-MM-dd'))?.status || 'absent',
      currentInTime: attendanceThisMonth.find((item) => item.date === format(new Date(), 'yyyy-MM-dd'))?.punch_in_time || 'N/A',
      currentOutTime: attendanceThisMonth.find((item) => item.date === format(new Date(), 'yyyy-MM-dd'))?.punch_out_time || 'N/A',
    };
  };

  const handleDateClick = (arg) => {
    const attendanceDataForDate = allAttendanceData.find((data) => data.date === arg.dateStr);
    if (attendanceDataForDate) {
      setPopupData({
        punchInTime: attendanceDataForDate.punch_in_time,
        punchOutTime: attendanceDataForDate.punch_out_time,
        date: attendanceDataForDate.date,
        status: attendanceDataForDate.status,
      });
      setShowPopup(true);
    }
  };

  const handleMouseOut = () => {
    setShowPopup(false);
  };

  const leaveDays = data.leave_requests && data.leave_requests.length > 0
    ? data.leave_requests.map((leaveRequest) => ({
        title: leaveRequest.leave_type,
        start: leaveRequest.start_date,
        end: leaveRequest.end_date,
        backgroundColor: '#a855f7',
        borderColor: '#a855f7',
        textColor: '#fff',
      }))
    : [];

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = '/';
  };

    const menuItems = [
    { icon: '&#127968;', label: 'Dashboard', path: '/user-dashboard' },
    { icon: '&#128100;', label: 'My Profile', path: `/user-profile/${userData?.id}` },
    { icon: '&#128197;', label: 'Attendance', path: `/leave-attendance/${userData?.id}` },
    { icon: '&#128203;', label: 'Leave Management', path: `/leave-management/${userData?.id}` },
    // { icon: '&#128197;', label: 'Calendar', path: '/calendar', condition: userData?.role_name === 'employee' },
    { icon: '&#9998;', label: 'Create AR Request', path: `/ar-request/${userData?.id}` },
    { icon: '&#128200;', label: 'My Calendar', path: '/my-calendar' },
    { icon: '&#128202;', label: 'AR Transactions', path: '/ar-transaction/' },
    // { icon: '&#128178;', label: 'Payroll', path: 'https://hrms.teamhalt.com/', active: false },
    { icon: '&#128179;', label: 'ID Card', action: () => setIsIdCardPopupVisible(true) },
  ];

  const profilePhotoUrl = userData?.profile_photo?.startsWith('http://') 
    ? userData?.profile_photo.replace('http://', 'https://') 
    : userData?.profile_photo;

  return (
    <div className={`dashboard-wrapper ${isSidebarVisible ? 'sidebar-open' : 'sidebar-closed'}`}>
      <Header 
        onToggleClick={handleToggleClick} 
        isSidebarVisible={isSidebarVisible} 
      />
      
      <Sidebar 
        isSidebarVisible={isSidebarVisible}
        currentUser={userData}
        menuItems={menuItems}
        handleLogout={handleLogout}
      />
      
      <div className="dashboard-main-content">
        <div className="my-calendar-container">
          <div className="my-calendar-header">
            <h1>My Calendar</h1>
            <p>View your attendance and leave schedule</p>
          </div>
          
          <div className="my-calendar-card">
            <FullCalendar 
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              initialView="dayGridMonth"
              events={[...events, ...leaveDays]} 
              headerToolbar={{
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay',
              }}
              dayRender={(date, cell) => {
                if (date.getDay() === 0 || date.getDay() === 6) {
                  cell.css("background-color", "#f1f5f9");
                }
              }}
              dateClick={handleDateClick}
              eventClick={handleDateClick}
              height="auto"
              aspectRatio={1.8}
            />
            
            {showPopup && (
              <div className="calendar-popup-overlay" onClick={() => setShowPopup(false)}>
                <div className="calendar-popup" onClick={(e) => e.stopPropagation()}>
                  <div className="calendar-popup-header">
                    <h3>Attendance Details</h3>
                    <button className="calendar-popup-close" onClick={() => setShowPopup(false)}>×</button>
                  </div>
                  <div className="calendar-popup-body">
                    <div className="calendar-popup-row">
                      <span className="popup-label">Date:</span>
                      <span className="popup-value">{popupData.date}</span>
                    </div>
                    <div className="calendar-popup-row">
                      <span className="popup-label">Status:</span>
                      <span className={`popup-status popup-status-${popupData.status}`}>
                        {popupData.status?.charAt(0).toUpperCase() + popupData.status?.slice(1)}
                      </span>
                    </div>
                    <div className="calendar-popup-row">
                      <span className="popup-label">Punch In:</span>
                      <span className="popup-value">{popupData.punchInTime || 'N/A'}</span>
                    </div>
                    <div className="calendar-popup-row">
                      <span className="popup-label">Punch Out:</span>
                      <span className="popup-value">{popupData.punchOutTime || 'N/A'}</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          
          <div className="calendar-legend">
            <div className="legend-item">
              <span className="legend-dot legend-present"></span>
              <span>Present</span>
            </div>
            <div className="legend-item">
              <span className="legend-dot legend-absent"></span>
              <span>Absent</span>
            </div>
            <div className="legend-item">
              <span className="legend-dot legend-leave"></span>
              <span>Leave</span>
            </div>
            <div className="legend-item">
              <span className="legend-dot legend-halfday"></span>
              <span>Half Day</span>
            </div>
            <div className="legend-item">
              <span className="legend-dot legend-missed"></span>
              <span>Missed Punch</span>
            </div>
            <div className="legend-item">
              <span className="legend-dot legend-holiday"></span>
              <span>Holiday / Weekly Off</span>
            </div>
          </div>
          
          <div className="attendance-stats-card">
            <div className="attendance-stats-header">
              <span className="stats-icon">📊</span>
              <h3>Attendance Summary - {format(new Date(), 'MMMM yyyy')}</h3>
            </div>
            <div className="attendance-stats-grid">
              <div className="stat-box stat-present">
                <span className="stat-number">{attendanceDetails.totalPresentDaysThisMonth || 0}</span>
                <span className="stat-label">Present Days</span>
              </div>
              <div className="stat-box stat-absent">
                <span className="stat-number">{attendanceDetails.totalAbsentDaysThisMonth || 0}</span>
                <span className="stat-label">Absent Days</span>
              </div>
              <div className="stat-box stat-halfday">
                <span className="stat-number">{attendanceDetails.totalHalfDaysThisMonth || 0}</span>
                <span className="stat-label">Half Days</span>
              </div>
              <div className="stat-box stat-today">
                <span className="stat-label">Today's Status</span>
                <span className={`current-status status-${attendanceDetails.currentStatus}`}>
                  {attendanceDetails.currentStatus?.charAt(0).toUpperCase() + attendanceDetails.currentStatus?.slice(1) || 'N/A'}
                </span>
              </div>
            </div>
            <div className="today-times">
              <div className="time-item">
                <span className="time-label">In Time:</span>
                <span className="time-value">{attendanceDetails.currentInTime || 'N/A'}</span>
              </div>
              <div className="time-item">
                <span className="time-label">Out Time:</span>
                <span className="time-value">{attendanceDetails.currentOutTime || 'N/A'}</span>
              </div>
              <div className="time-item">
                <span className="time-label">Date:</span>
                <span className="time-value">{format(new Date(), 'dd MMMM yyyy')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* ID Card Popup */}
      {isIdCardPopupVisible && (
        <div className="id-card-overlay" onClick={() => setIsIdCardPopupVisible(false)}>
          <div className="id-card-popup" onClick={(e) => e.stopPropagation()}>
            <button className="id-card-close" onClick={() => setIsIdCardPopupVisible(false)}>×</button>
            
            <div className="id-card-header">
              <img src="/Teamhalt.png" alt="Logo" className="id-card-logo" />
              <span>TEAMHALT PRIVATE LIMITED</span>
            </div>
            
            <div className="id-card-body">
              <div className="id-card-profile">
                <img
                  src={profilePhotoUrl || '/profile.jpg'}
                  alt="Profile"
                  className="id-card-photo"
                />
                <div className="id-card-info">
                  <h4>{userData?.first_name} {userData?.last_name}</h4>
                  <p className="id-designation">{userData?.designation}</p>
                  <div className="id-dob">
                    <strong>DOB:</strong>
                    <span>
                      {userData?.date_of_birth
                        ? new Date(userData.date_of_birth).toLocaleDateString("en-GB").replace(/\//g, "-")
                        : "N/A"}
                    </span>
                  </div>
                </div>
              </div>
              
              <hr className="id-card-divider" />
              
              <div className="id-card-details">
                {[
                  { label: "Emp ID", value: userData?.employee_code },
                  { label: "Department", value: userData?.department },
                  { label: "ESIC No.", value: userData?.esic_no },
                  { label: "UAN No.", value: userData?.uan_no },
                  { label: "Gender", value: userData?.gender },
                  { label: "Contact No.", value: userData?.contact_number },
                ].map((item, idx) => (
                  <div key={idx} className="detail-row">
                    <strong>{item.label}:</strong>
                    <span>{item.value || "N/A"}</span>
                  </div>
                ))}
              </div>
              
              {typeof userData?.work_location_name === "string" &&
                userData.work_location_name.toLowerCase() !== "noida" && (
                <div className="id-card-duty">
                  <strong>On Contractual Duty Of:</strong>
                  <span>{userData?.duty_of || "N/A"}</span>
                </div>
              )}
              
              <div className="id-card-footer">
                https://teamhalt.com/
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyCalendar;